import React from 'react';
import LiveCallsSection from '../../components/LiveCalls/LiveCallsSection';

const LiveCallsPage: React.FC = () => (
  <div className="p-6">
    <LiveCallsSection />
  </div>
);

export default LiveCallsPage;
